<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="d-sm-none col-form-label" for="steuerpflichtigerJahrBetriebseroeffnung{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.STPFL' | translate }}
    </label>
    <div class="col-sm-3">
      <input class="form-control text-right pr-3x" datevMessagePath="steuerpflichtigerJahrBetriebseroeffnung{{objectId}}" formControlName="steuerpflichtigerJahrBetriebseroeffnung"
             id="steuerpflichtigerJahrBetriebseroeffnung{{index}}"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsValidationMessage/>
      <em class="icon-euro"></em>
    </div>

    <label class="d-sm-none col-form-label" for="ehepartnerJahrBetriebseroeffnung{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.EHEPARTNER' | translate }}
    </label>
    <div class="col-sm-3">
      <input class="form-control text-right pr-3x" datevMessagePath="ehepartnerJahrBetriebseroeffnung{{objectId}}" formControlName="ehepartnerJahrBetriebseroeffnung"
             id="ehepartnerJahrBetriebseroeffnung{{index}}"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsValidationMessage/>
      <em class="icon icon-euro"></em>
    </div>

    <label class="d-sm-none col-form-label" for="steuerpflichtigerFolgejahr{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.STPFL_FOLGEJAHR' | translate }}
    </label>
    <div class="col-sm-3">
      <input class="form-control text-right pr-3x" datevMessagePath="steuerpflichtigerFolgejahr{{objectId}}" formControlName="steuerpflichtigerFolgejahr"
             id="steuerpflichtigerFolgejahr{{index}}"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsValidationMessage/>
      <em class="icon icon-euro"></em>
    </div>

    <label class="d-sm-none col-form-label" for="ehepartnerFolgejahr{{index}}">
      {{ 'COMMON_UI.FRAGEBOGEN.FESTSETZUNG_VORAUSZAHLUNG.GRUNDLAGE_VORAUSZAHLUNGEN.EHEPARTNER_FOLGEJAHR' | translate }}
    </label>
    <div class="col-sm-3">
      <input class="form-control text-right pr-3x" datevMessagePath="ehepartnerFolgejahr{{objectId}}" formControlName="ehepartnerFolgejahr" id="ehepartnerFolgejahr{{index}}"
             type="text" numeric negativeAllowed transformNumber
             utilsCheckValidity utilsControlState utilsValidationMessage/>
      <em class="icon icon-euro"></em>
    </div>
  </div>

</form>
